<template>
  <v-app id="Moonsyst" :class="$domain == $hwUrl ? 'Herdwatch':''" >
    <page-header />
    <v-content>
      <staging-label />
      <maintenance-label />
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
      <!-- </v-container> -->
    </v-content>
  </v-app>
</template>

<script>
import PageHeader from "@/components/Header.vue";
import StagingLabel from "@/components/StagingLabel.vue";
import MaintenanceLabel from "@/components/MaintenanceLabel.vue"

export default {
  name: "",
  components: {
    PageHeader,
    StagingLabel,
    MaintenanceLabel
  },
  mounted() {
    // Update favicon on mount    
    if(this.$domain != this.$hwUrl) {
      return;
    }

    const hostname = 'herdwatch'; // Default to 'herdwatch' if its not Moonsyst

    // Define domain-specific favicons
    const externalFavicon = {
      'herdwatch': {
        '16x16': '/static/icons/herdwatch/favicon-16x16.png',
        '32x32': '/static/icons/herdwatch/favicon-32x32.png',
        'shortcut': '/static/icons/herdwatch/favicon.ico'
      }
    }

    const sizes = ['16x16', '32x32'];
    sizes.forEach(size => {
      let link = document.querySelector(`link[rel="icon"][sizes="${size}"]`);
      if (link && externalFavicon[hostname][size]) {
        link.href = externalFavicon[hostname][size];
      }
    });

    // Update the shortcut icon
    let shortcutLink = document.querySelector('link[rel="shortcut icon"]');
    if (shortcutLink && externalFavicon[hostname]['shortcut']) {
      shortcutLink.href = externalFavicon[hostname]['shortcut'];
    }
  }
};
</script>

<style>
#Moonsyst {
  font-family: "Montserrat", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background: var(--v-background);
}

.bg-login {
  background: none !important;
  background-color: var(--v-bg_login) !important;
}

.env-wrapper {
  padding: 4px;
  padding-right: 24px;
  text-align: right;
  background: var(--v-secondary);
  /* margin-left: 300px;
  width: calc(100% - 300px);
  */
  font-weight: bold;
  font-size: 12px;
  color: white;
}

label i {
  margin-right: 10px !important;
}

.danger-alert {
  color: red;
}

tbody > tr {
  cursor: pointer;
}
.date-field {
  border-bottom: 1px solid #2c3e50;
}

.logo {
  max-height: 120px;
  /* min-width: 40px; */
  width: auto;
  align-self: left;
  text-align: start;
}

.icon-secondary {
  color: var(--v-secondary) !important;
}

.modal-button-row {
  margin-right: -24px;
  margin-left: -24px;
  margin-bottom: -8px;
}

.button-modal {
  margin-bottom: 0;
  border-radius: 0;
}

button.theme--dark.button-delete {
  background-color: var(--v-accent) !important;
  color: var(--v-secondary);
}

/*
*:not(.v-date-picker-table) tr:nth-child(even) {
  background: #efefef;
}


tbody > tr:hover {
  background-color: rgb(201, 201, 201) !important;
}

tr {
  border: none !important;
}
*/

.side-panel {
  height: 100%;
  width: 80%;
  background: white;
}

.floatin {
  height: 100%;
  background-color: white;
}

.app-icon {
  height: 20px;
  width: 20px;
}
.search-icon {
  max-width: 20px;
  max-height: 20px;
  height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue